function createIframe(src) {
    return `
    <div style="position: relative; overflow: hidden; width: 100%; height: 400px;">
      <iframe
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        src="${src}" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="lazy" allowtransparency="true"
        height="400" width="100%"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
      >
      </iframe>
    </div>
  `;
}
function isCodePenUrl(url) {
    const domains = ["codepen.io", "cdpn.io"];
    return domains.some(d => url.indexOf(d) !== -1);
}
export const codePenEmbedExtension = {
    name: 'codepenembed',
    level: 'block',
    start(src) {
        var _a;
        return (_a = src.match(/[^\S\r\n]*\n*%\[[^\n]*\]/)) === null || _a === void 0 ? void 0 : _a.index;
    },
    tokenizer(src) {
        const rule = /^[^\S\r\n]*%\[([^\n]*)\]/;
        const cap = rule.exec(src);
        if (cap) {
            const codePen = cap[1];
            if (isCodePenUrl(codePen)) {
                const token = {
                    type: 'codepenembed',
                    raw: cap[0],
                    text: codePen,
                    tokens: []
                };
                return token;
            }
        }
    },
    renderer(token) {
        return createIframe(token.text);
    }
};
